export default __webpack_public_path__ + "static/media/WebExpand.fd11dfc6.svg";